var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"backdrop-container",on:{"click":function($event){return _vm.close()}}},[_c('div',{staticClass:"backdrop"},[_vm._v(" ")]),_vm._v(" "),(_vm.$store.getters.backdropMessage)?_c('p',{staticClass:"backdrop-message"},[_vm._v(_vm._s(_vm.$store.getters.backdropMessage))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ab36dc","hasScoped":true,"buble":{"transforms":{}}}!./src/components/backdrop/template.html
// module id = 607
// module chunks = 0